// utils/assetFolderMap.js
export const assetFolderMap = {
  '/projects/nasa-project': 'nasa-project',
  '/projects/interactive-coder': 'interactive-coder',
  '/projects/dfm-project': 'dfm-project',
  '/projects/robotic-arm-project': 'robotic-arm-project',
  '/projects/turbojet-project': 'turbojet-project',
  '/about-me': 'about-me',
  '/': 'home',
  // Skills pages
  '/skills/gas-dynamics': 'skills/gas-dynamics',
  '/skills/combustion': 'skills/combustion',
  '/skills/thermo-dynamics': 'skills/thermo-dynamics',
  '/skills/fluid-mechanics': 'skills/fluid-mechanics',
  '/skills/mech-engr-methods': 'skills/mech-engr-methods',
  '/skills/instrumentation-&-measurements': 'skills/instrumentation-&-measurements',
  '/skills/sdc': 'skills/SDC',
};
